import { AxiosInstance, AxiosProgressEvent, Method, ResponseType } from 'axios';

import {
  APIErrorHandlingOptions,
  processApiError,
} from '@/utils/api/ApiDefault';
import { ApiTokenType } from '@/types/api';
import * as process from 'process';
import { jwtInstance } from '@/utils/api/jwt/instance';

export const fetchApi = async <T = unknown>({
  instance = jwtInstance,
  method,
  url,
  baseURL = process.env.NEXT_PUBLIC_API_URL,
  data,
  apiTokenType = ApiTokenType.JWT,
  isOldPortal = false,
  deviceCode,
  extraHeaders,
  errorHandlingOptions,
  timeout = 300000, // 기본값 30초로 설정
  signal,
  responseType,
  onUploadProgress,
}: {
  instance?: AxiosInstance;
  method: Method;
  url: string;
  isOldPortal?: boolean;
  baseURL?: string;
  data?: Record<string, unknown>;
  apiTokenType?: ApiTokenType;
  deviceCode?: string;
  extraHeaders?: Record<string, unknown>;
  errorHandlingOptions?: APIErrorHandlingOptions;
  timeout?: number; //
  signal?: AbortSignal;
  responseType?: ResponseType;
  /** 업로드 진행률 — 진척 표시/스톨 감지용 (PORTAL-12593) */
  onUploadProgress?: (event: AxiosProgressEvent) => void;
}): Promise<T> => {
  const headers: Record<string, string> = {};
  if (deviceCode) headers.deviceCode = deviceCode;
  if (extraHeaders) Object.assign(headers, extraHeaders);

  Object.assign(headers, {
    api_token_type: apiTokenType,
  });

  if (process.env.NODE_ENV === 'development') {
    console.log(`👉 [${method}] ${url}`);
  }

  return await instance<T>({
    method,
    url: isOldPortal ? `/api/v1/proxy/old-portal${url}` : url,
    data,
    baseURL,
    headers,
    timeout,
    signal,
    responseType,
    onUploadProgress,
  })
    .then((res) => res.data)
    .catch((err) => {
      if (process.env.NODE_ENV === 'development') {
        console.log(`❌ [${method}] ${url}`);
      }
      throw processApiError(err, errorHandlingOptions);
    });
};
